import React, { useCallback, useEffect, useMemo, useState } from "react";
import Errors from "../../../constants/Errors.json";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router-dom";

import variables from "../../../constants/assets/variables";
import NoFooterModal from "../../Common/NoFooterModal";
import {
  BottomSectionModal,
  NotesSection,
  UploadCsvOption,
} from "../../../constants/assets/containers";
import FileUpload from "../../Common/FileUpload";
import InformationBar from "../../Common/InformationBar";
import Button from "sushiweb/Button";
import * as UserActions from "../../../store/actions/User";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";

export const sourceTypeOptions = [
  { label: "Driver", value: "driver" },
  { label: "City", value: "city" },
  { label: "Locality", value: "locality" },
];
const BulkCsvUploadFile = ({
  sampleURL, //sample url of file to download
  filename, //filename to be send in payload
  setStatus,
  setUploadedFileName,
  setActiveFilePath,
  heading, //heading of the modal
  id, //id of the modal (mandatory field)
  btnDataTestID, //data-testid of confirm button (mandatory field for testing)
  keyName, //keyName of the key to be send in acknowledgement
  uploadUrl, //upoadUrl is the url on which the ack will be sent
  getUploadUrl, //function for api call
  closeUrl, // url where it should redirect when closed
  customHandleClose, // pass function if want to handle modal close by yourself
  useUserUploadedFilename, // pass boolean value if to use filename of file uploaded by user or not
  filterTypes = [], // array of values for filtering
  validationType = "", // for CSV file validation of your choice
  maxSize, //maximum file size in MB
  acceptedFileFormat,
  noAckCall,
}) => {
  const history = useHistory();
  const [activeFile, setActiveFile] = useState("");
  const [callback_key, setCallback_key] = useState("");
  const [presign_url, setPresign_url] = useState("");
  const [uploadScope, setUploadScope] = useState(sourceTypeOptions[0]);
  const [file_path, setFile_path] = useState("");
  const [sample_download_url, setSampleDownloadUrl] = useState("");
  const [loadingBtn, setLoadingBtn] = useState(false);

  useEffect(() => {
    const download_url = `${
      process.env.REACT_APP_API_URL
        ? `${process.env.REACT_APP_API_URL.replace(
            variables.routeEndpoint,
            variables.sampleFileEndPoint
          )}${sampleURL}`
        : ""
    }`;

    if (sampleURL) {
      setSampleDownloadUrl(download_url);
    }
  }, []);

  const handleClose = useCallback(() => {
    if (customHandleClose) {
      customHandleClose();
      return;
    }
    if (closeUrl) {
      history.push(closeUrl);
    } else {
      history.push("/");
    }
  }, [closeUrl, customHandleClose]);

  const handleFileUploadSuccess = () => {
    if (activeFile.name) {
      setUploadedFileName(activeFile.name);
    }
    setActiveFilePath(file_path);
  };

  const handleSubmit = (e) => {
    setLoadingBtn(true);
    e.preventDefault();
    if (useUserUploadedFilename) {
      filename = activeFile.name;
    }

    getUploadUrl({
      filename: filename || "bulk_upload_file",
      scope: uploadScope.value,
    }).then((res) => {
      setTimeout(() => setLoadingBtn(false), 3000);
      if (res) {
        setFile_path(res.file_path);
        setCallback_key(res.callback_key);
        setPresign_url(res.file_upload_url);
      } else {
        setStatus({ type: "error", message: Errors.GENERAL_ERROR });
      }
    });
  };

  const CheckIfButtonDisabled = () => {
    return activeFile === "";
  };

  const handleChange = (selectedOption) => {
    setUploadScope(
      sourceTypeOptions.find((item) => item.value === selectedOption)
    );
  };
  return (
    <section>
      <NoFooterModal
        header
        heading={heading || "Bulk File Upload"}
        handleClose={handleClose}
        id={id || "bulkUploadModal"}
        modalButtons={
          <BottomSectionModal>
            <Button
              data-testid={btnDataTestID}
              disabled={CheckIfButtonDisabled()}
              onClick={handleSubmit}
              loading={loadingBtn}
              className="sushi-btn"
            >
              Confirm
            </Button>
          </BottomSectionModal>
        }
      >
        <PaginatedReactDropdown
          options={sourceTypeOptions}
          handleSelect={handleChange}
          placeholder="Upload Scope"
          showCross={true}
          showPagination={false}
          value={uploadScope?.label ?? ""}
          id="uploadScopeDropdown"
          labelKey={"label"}
          valueKey={"value"}
        />
        <UploadCsvOption>
          <FileUpload
            title="CSV file"
            uploadUrl={uploadUrl}
            callback_key={callback_key}
            presign_url={presign_url}
            handleClose={handleClose}
            keyName={keyName || "callback_key"}
            activeFile={activeFile}
            setActiveFile={setActiveFile}
            maxSize={maxSize}
            acceptTypes={
              acceptedFileFormat ? acceptedFileFormat : ".csv, .xls, .xlsx"
            }
            handleFileUploadSuccess={handleFileUploadSuccess}
            validationType={validationType}
            noAckCall={noAckCall}
          />
        </UploadCsvOption>
        <NotesSection>
          <InformationBar
            sampleUrl={sample_download_url}
            instructions={
              uploadScope?.value === "driver"
                ? [
                    "Provide delivery driver IDs (e.g. 34897) as per format given in the sample CSV under entity_id.",
                    "We do not accept FE ids. Eg: FE17823 is not acceptable, but 7823 is acceptable",
                  ]
                : uploadScope?.value === "city"
                ? [
                    "Provide city ids as per format given in the sample CSV under entity_id.",
                  ]
                : [
                    "Provide locality ids as per format given in the sample CSV under entity_id.",
                  ]
            }
          />
        </NotesSection>
      </NoFooterModal>
    </section>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    setUploadedFileName: bindActionCreators(
      UserActions.setUploadedFileName,
      dispatch
    ),
    setActiveFilePath: bindActionCreators(
      UserActions.setActiveFilePath,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(BulkCsvUploadFile);
